import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { FaAward, FaUsers } from "react-icons/fa"; // Icônes

const AboutSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  return (
    <section
      ref={ref}
      className="about-section-responsive"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "50px",
        backgroundColor: "#ffffff",
        flexWrap: "wrap",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
     
      <motion.div
        className="about-image-container-responsive"
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          position: "relative", 
          width: "320px", 
          height: "auto",

        }}
        initial={{ opacity: 0, x: -50 }}
        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {/* Seconde image (arrière-plan) */}
        <img
          src="../assets/images/image6.png"
          alt="Experts comptables"
          className="about-image-back"
          style={{
            width: "270px",
            height: "270px",
            borderRadius: "10px",
            boxShadow: "0px 10px 20px hsla(0, 0.00%, 0.00%, 0.10)",
            transform: "rotate(20deg)",
            marginLeft: "200px", 
          }}
        />

        
        <img
          src="../assets/images/image5.png"
          alt="Équipe de comptabilité"
          className="about-image-front"
          style={{
            width: "300px",
            height: "400px",
            borderRadius: "10px",
            position: "absolute",
            top: "-20px", 
            marginRight: "180px", 
            transform: "rotate(-5deg)", 
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)",
            zIndex: 2, 
          }}
        />
      </motion.div>

      
      <motion.div
        className="about-text-container-responsive"
        style={{
          flex: 1,
          paddingLeft: "50px",
          textAlign: "left",
          maxWidth: "600px",
        }}
        initial={{ opacity: 0, x: 50 }}
        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
      >
        <h2 className="about-title-responsive" style={{ fontSize: "2rem", fontWeight: "bold", color: "#222", marginTop: "20px" }}>
          Accompagner les entreprises avec{" "}
          <span
            className="about-title-highlight"
            style={{
              fontSize: "2rem",
              fontWeight: "bold",
              background: "linear-gradient(to right, #00a859, #d91e36)",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            des solutions innovantes
          </span>
        </h2>

        <p style={{ fontSize: "1rem", color: "#555", margin: "20px 0" }}>
          Nous nous engageons à fournir des solutions comptables et financières adaptées aux besoins des entreprises.
          Avec une équipe d'experts passionnés, nous accompagnons votre croissance avec une approche centrée sur votre business.
        </p>

        <div className="about-cards-container" style={{ display: "flex", gap: "15px", marginTop: "25px" }}>
          <motion.div
            style={{
              flex: 1,
              backgroundColor: "#f8f9fa",
              padding: "12px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
              transition: "transform 0.3s ease-in-out",
            }}
            whileHover={{ scale: 1.1 }}
          >
            <FaAward style={{ color: "#d91e36", fontSize: "2rem", marginRight: "10px" }} />
            <div>
              <span style={{ fontSize: "1rem", fontWeight: "bold", color: "#222" }}>
                Déclaration fiscale
              </span>
            </div>
          </motion.div>

          <motion.div
            style={{
              flex: 1,
              backgroundColor: "#f8f9fa",
              padding: "12px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
              transition: "transform 0.3s ease-in-out",
            }}
            whileHover={{ scale: 1.1 }}
          >
            <FaUsers style={{ color: "#00a859", fontSize: "2rem", marginRight: "10px" }} />
            <div>
              <span style={{ fontSize: "1rem", fontWeight: "bold", color: "#222" }}>
                Assistance comptable
              </span>
            </div>
          </motion.div>
        </div>

        
        <div
          className="about-stats-container"
          style={{
            marginTop: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              background: "linear-gradient(to right, #00a859, #d91e36)",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            10<span style={{ color: "transparent" }}>+</span>
          </span>
          <span style={{ fontSize: "1.2rem", color: "#222", fontWeight: "bold" }}>
            Années d'expérience en expertise comptable
          </span>

          <Link
            to="/biography"
            style={{
              background: "linear-gradient(to right, #00a859, #d91e36)",
              color: "white",
              padding: "12px 20px",
              fontSize: "1rem",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              transition: "0.3s ease-in-out",
              width: "140px",
              textAlign: "center",
            }}
            onMouseOver={(e) => (e.target.style.opacity = "0.8")}
            onMouseOut={(e) => (e.target.style.opacity = "1")}
          >
            Voir plus
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

// Styles CSS pour la responsive
const aboutSectionStyles = `
  /* Responsive AboutSection styles */
  @media (max-width: 1199px) {
    .about-section-responsive {
      padding: 40px 30px !important;
    }
    
    .about-text-container-responsive {
      padding-left: 30px !important;
    }
    
    .about-title-responsive {
      font-size: 1.8rem !important;
    }
    
    .about-title-highlight {
      font-size: 1.8rem !important;
    }
  }

  @media (max-width: 991px) {
    .about-section-responsive {
      flex-direction: column !important;
      padding: 30px 20px !important;
      text-align: center !important;
    }
    
    .about-image-container-responsive {
      width: 100% !important;
      margin-bottom: 30px !important;
      justify-content: center !important;
    }
    
    .about-text-container-responsive {
      padding-left: 0 !important;
      text-align: center !important;
      max-width: 100% !important;
    }
    
    .about-image-back {
      width: 200px !important;
      height: 200px !important;
      margin-left: 120px !important;
    }
    
    .about-image-front {
      width: 220px !important;
      height: 280px !important;
      margin-right: 100px !important;
    }
  }

  @media (max-width: 768px) {
    .about-section-responsive {
      padding: 25px 15px !important;
    }
    
    .about-title-responsive {
      font-size: 1.6rem !important;
    }
    
    .about-title-highlight {
      font-size: 1.6rem !important;
    }
    
    .about-cards-container {
      flex-direction: column !important;
      gap: 12px !important;
    }
    
    .about-stats-container {
      flex-direction: column !important;
      gap: 20px !important;
      text-align: center !important;
    }
    
    .about-image-back {
      width: 180px !important;
      height: 180px !important;
      margin-left: 80px !important;
      transform: rotate(15deg) !important;
    }
    
    .about-image-front {
      width: 200px !important;
      height: 250px !important;
      margin-right: 60px !important;
    }
  }

  @media (max-width: 576px) {
    .about-section-responsive {
      padding: 20px 10px !important;
    }
    
    .about-title-responsive {
      font-size: 1.4rem !important;
      margin-bottom: 15px !important;
    }
    
    .about-title-highlight {
      font-size: 1.4rem !important;
    }
    
    .about-image-container-responsive {
      width: 100% !important;
      height: 200px !important;
      margin-bottom: 25px !important;
    }
    
    .about-image-back {
      width: 140px !important;
      height: 140px !important;
      margin-left: 40px !important;
      transform: rotate(10deg) !important;
    }
    
    .about-image-front {
      width: 160px !important;
      height: 200px !important;
      margin-right: 20px !important;
      top: -10px !important;
    }
    
    .about-stats-container {
      margin-top: 25px !important;
    }
    
    .about-stats-container span:first-child {
      font-size: 2.5rem !important;
    }
    
    .about-stats-container span:nth-child(2) {
      font-size: 1rem !important;
      margin: 10px 0 !important;
    }
    
    .about-stats-container a {
      width: 120px !important;
      padding: 10px 15px !important;
      font-size: 0.9rem !important;
    }
  }

  @media (max-width: 400px) {
    .about-title-responsive {
      font-size: 1.2rem !important;
    }
    
    .about-title-highlight {
      font-size: 1.2rem !important;
    }
    
    .about-image-back {
      width: 120px !important;
      height: 120px !important;
      margin-left: 30px !important;
    }
    
    .about-image-front {
      width: 140px !important;
      height: 180px !important;
      margin-right: 10px !important;
    }
  }
`;

// Injection des styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = aboutSectionStyles;
document.head.appendChild(styleSheet);

export default AboutSection;
